import { takeEvery, call, put } from 'redux-saga/effects';
import categoryApi from 'api/employee/categoryApi';
import * as categoryActions from 'redux/ducks/setting/integrationCategoryDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';

export function* getCategoryListFromDB({ payload }) {
  try {
    const response = yield call(categoryApi.getCategoryListFromDB, payload);
    yield put(categoryActions.getCategoryListFromDBSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* removeCategory({ payload }) {
  try {
    const response = yield call(categoryApi.removeCategory, payload);
    yield put(categoryActions.removeCategorySuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* changeCount() {
  yield put(categoryActions.changeCountSuccess());
}

export function* changeOrderCategories({ payload }) {
  try {
    const _payload = { ...payload };
    delete _payload.closeFunction;
    const response = yield call(categoryApi.changeOrderCategory, _payload);
    yield put(categoryActions.changeOrderCategoriesSuccess(response));
    payload.closeFunction();
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export default function* integrationCategorySaga() {
  yield takeEvery(categoryActions.getCategoryListFromDB, getCategoryListFromDB);
  yield takeEvery(categoryActions.removeCategory, removeCategory);
  yield takeEvery(categoryActions.changeCount, changeCount);
  yield takeEvery(categoryActions.changeOrderCategories, changeOrderCategories);
}
